import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DisciplineStatusCircleComponent } from './discipline-status-circle.component';

@NgModule({
  declarations: [DisciplineStatusCircleComponent],
  imports: [CommonModule],
  exports: [DisciplineStatusCircleComponent],
})
export class DisciplineStatusCircleModule {}
